export const COLUMNS_HEADERS = {
  docket_number: {
    searchable: true,
    sortable: true,
    ascSort: true,
    integer: true,
  },
  arriving_date: { sortable: true },
};
